import {Dispatch, SetStateAction} from "react";
import {Copy as CopyToClipboardIcon} from "react-bootstrap-icons";
import {useTranslation} from "react-i18next";
import {StringUtils} from "../utils/StringUtils";

export interface CopyToClipboardProps {
    value : string | undefined
    setCopied? : Dispatch<SetStateAction<boolean>>
}

export const CopyToClipboard = ({value, setCopied}: CopyToClipboardProps) =>
{
    /**
     * i18next translation hook
     */
    const {t} = useTranslation('components');

    return (
        <button className="border-0 text-bg-primary"
                title={t('common.copy-to-clipboard-title')}
                disabled={StringUtils.isBlank(value)}
                onClick={(e) => {
                    navigator.clipboard.writeText(value ?? "");
                    if (setCopied !== undefined) {
                        setCopied(true);
                    }
                    e.preventDefault()
                }}>
            <CopyToClipboardIcon/>
        </button>
    )
};
